module.exports = __webpack_public_path__ + "img/success-icon.992f7f55.png";